import { ts_hocsinh_lichsu_yte_type } from "../models/response/hoc-sinh/ts_hocsinh_lichsu_yte_type";
import { apiClient } from "./apiClient";

export const HOC_SINH_LICH_SU_Y_TE_TYPE_END_POINT = "hoc-sinh-lich-su-y-te-type";

export const hocSinhLichSuYTeTypeApi = {
    selectAll: () => apiClient.get(HOC_SINH_LICH_SU_Y_TE_TYPE_END_POINT),
    detail: (id: number) => apiClient.get(`${HOC_SINH_LICH_SU_Y_TE_TYPE_END_POINT}/${id}`),
    insert: (payload: ts_hocsinh_lichsu_yte_type) => apiClient.post(HOC_SINH_LICH_SU_Y_TE_TYPE_END_POINT, payload),
    update: (payload: ts_hocsinh_lichsu_yte_type) => apiClient.put(HOC_SINH_LICH_SU_Y_TE_TYPE_END_POINT, payload),
    delete: (id: number) => apiClient.delete(`${HOC_SINH_LICH_SU_Y_TE_TYPE_END_POINT}/${id}`),
};
